module.exports = __webpack_public_path__ + "media/images/athletes/3391-a1136fa36ad241025c3299b8e4b9a461.png";